/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React from 'react'

interface LogoProps {
  className?: string
  showTagline?: boolean
  variant?: 'header' | 'footer' | 'mobile'
}

export const Logo: React.FC<LogoProps> = ({
  className,
  variant = 'header',
}) => {
  const logoSrc = new URL('../Asset/logo.png', import.meta.url).href

  const defaultClasses = {
    header: 'h-6 sm:h-7 md:h-8',
    footer: 'h-8 sm:h-9 md:h-10',
    mobile: 'h-6 sm:h-7 md:h-8',
  }

  const selectedClass = className || defaultClasses[variant] || 'h-6 sm:h-7 md:h-8'

  const imgClasses = {
    header: 'max-h-6 sm:max-h-7 md:max-h-8 max-w-[120px] sm:max-w-[140px] md:max-w-[160px]',
    footer: 'max-h-8 sm:max-h-9 md:max-h-10 max-w-[140px] sm:max-w-[160px] md:max-w-[180px]',
    mobile: 'max-h-6 sm:max-h-7 md:max-h-8 max-w-[120px] sm:max-w-[140px] md:max-w-[160px]',
  }

  const selectedImgClass = imgClasses[variant] || imgClasses.header

  return (
    <div className={`flex items-center select-none ${selectedClass}`} id="brand_logo_wrapper">
      <img
        src={logoSrc}
        alt="Tag Express"
        className={`h-auto w-auto object-contain hover:scale-105 transition-all duration-300 dark:dark-logo-shadow ${selectedImgClass}`}
        id="brand_logo_img"
        referrerPolicy="no-referrer"
      />
    </div>
  )
}

export default Logo
